<template>
  <main id="home">
    <div style="position: relative; height: 380px">
      <globe-rotate/>
      <div class="mask" style="background: rgba(0,0,0,.3)">
        <self-introduction/>
      </div>
    </div>
    <timeline :list=timeline.itemList :title=timeline.title></timeline>
  </main>
</template>

<script>
import SelfIntroduction from 'components/SelfIntroduction'
import Timeline from 'components/Timeline'
import GlobeRotate from 'components/GlobeRotate/GlobeRotate'

export default {
  name: 'Home',
  components: {
    SelfIntroduction, Timeline, GlobeRotate
  },
  data(){
    return {
      timeline: {
        title: 'SKILLS',
        itemList: [{
          icon: 'globe',
          title: 'HTML/CSS',
          desc: ['能够编写语义化的 HTML，模块化的 CSS，完成较复杂的布局', '熟悉 Less Sass Autoprefixer 等CSS预处理和模块化工具']
        },{
          icon: 'paper-plane',
          title: 'JavaScript',
          desc: ['熟悉原生 Javascript，能脱离 jQuery 等类库编码', '能运用模块化、面向对象的方式编程']
        },{
          icon: 'eye',
          title: '前端工程化',
          desc: ['熟悉基本Webpack、Git、Gulp等工具的使用','了解前端安全、性能优化方面的一些知识','了解基本 Node.js 的开发']
        },{
          icon: 'heartbeat',
          title: '流行技术',
          desc: ['熟练使用Vue全家桶构建网站','熟悉Echarts绘制图表','开发微信小程序']
        }]
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue